import { SequenceMenu, SequenceMenuDivider } from '@sequencehq/core-components'
import { useSetAtom } from 'jotai'
import { deleteMinimumAtom } from '../../atoms/reviewPricing.atoms'
import { taskDrawerConfigAtom } from '../../../../../atoms'

export const MinimumKebabMenu = (props: {
  phaseId: string
  minimumId: string
  'data-testid'?: string
}) => {
  const deleteMinimum = useSetAtom(deleteMinimumAtom)
  const setDrawer = useSetAtom(taskDrawerConfigAtom)

  return (
    <SequenceMenu
      variant="ghost"
      buttonSize="small"
      alignment="bottom-right"
      data-testid={props['data-testid']}
      items={[
        ({ setIsOpen }) => (
          <SequenceMenu.Item
            key="editMinimum"
            uuid="edit-minimum"
            label="Edit minimum"
            data-testid={props['data-testid'] && `${props['data-testid']}.edit`}
            onClick={() => {
              setDrawer({
                type: 'MINIMUM',
                phaseId: props.phaseId,
                minimumId: props.minimumId
              })
              setIsOpen?.(false)
            }}
          />
        ),
        <SequenceMenuDivider key="divider" />,
        ({ setIsOpen }) => (
          <SequenceMenu.Item
            key="Remove minimum"
            uuid="remove-minimum"
            label="Remove minimum"
            data-testid={
              props['data-testid'] && `${props['data-testid']}.delete`
            }
            onClick={() => {
              deleteMinimum({
                phaseId: props.phaseId,
                minimumId: props.minimumId
              })
              setIsOpen?.(false)
            }}
            destructive
          />
        )
      ]}
    />
  )
}
